import { TOC } from '../table-of-contents/table-of-contents';
export function generictocPage() {
    const tocCreate = document.querySelector('[data-toccreate]');
    const tocNavElement = document.querySelector('[data-tocnav]');
    if (!tocCreate || !tocNavElement)
        return;
    const headingSet = tocCreate.querySelectorAll('h2');
    if (!headingSet.length) {
        tocNavElement.remove();
    }
    else {
        const tocData = TOC.parse(headingSet);
        const tocNavigation = TOC.build(tocData);
        tocNavElement.innerHTML = tocNavigation;
    }
}
generictocPage();
//# sourceMappingURL=generictoc-page.js.map